import { connect } from 'react-redux';
import UnitInfo from './UnitInfo';

const mapStateToProps = (state, ownProps) => {
  const unitId = ownProps.unit.unit;
  const unit = state.units[unitId];
  const notes = unit && unit.info;
  return {
    pathNamespace: state.booking.pathNamespace,
    notes
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnitInfo);



// WEBPACK FOOTER //
// ./src/containers/UnitInfo/index.js